export default __webpack_public_path__ + "static/media/investors.1c85adfe.wav";